import { createContext, useContext } from 'react';

/**
 * Vague 7 : « Voir ce que voit mon client ». La vue du portail est affichée **dans l'espace garage**, sans
 * jeton : les images passent alors par les routes du garage (session du membre, après contrôle), la fiche de
 * réception n'est pas demandée au portail, et l'ensemble est inerte (aucune décision ni question possible).
 * Hors aperçu (`null`), le portail charge ses images avec le jeton du client, comme avant.
 */
export interface PortalPreviewSource {
  /** Photo publiée du dossier (`media.file` du garage). */
  mediaUrl: (id: string, variant: 'thumb' | 'display') => string;
  /** Photo du véhicule (`profilePhotos.file`), ou `null`. */
  vehiclePhotoUrl: (variant: 'thumb' | 'display') => string | null;
}

export const PortalPreviewContext = createContext<PortalPreviewSource | null>(null);

export function usePortalPreview(): PortalPreviewSource | null {
  return useContext(PortalPreviewContext);
}
